export default (data) => /* html */ `
<a href="/myaccount:autoreorder/detail/r/${data.id}">
  <p class="alert alert-info lastPurchased reorder">
    This item will be auto reordered on<br><strong>${data.date}</strong>
  </p>
</a>`;
